/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
import {
    DELETE_PRODUCT,
    FETCH_PRODUCTS_DATA,
    FETCH_PRODUCTS_SUMMARY,
    GET_PRODUCT_CATEGORIES,
    INPUT_IMAGE_MULTIPLE,
    INPUT_IMAGE_FEATURE,
    PRODUCT_FORM_INPUT,
    PRODUCT_FORM_INPUT_ARRAY,
    RESET_FEATURE_IMAGE,
    RESET_PRODUCT_FORM,
    SET_LOADING_STATE,
    SET_SINGLE_PRODUCT,
    PRODUCT_DOWNLOADABLE,
    SET_COVER_IMAGE_STATE,
    SET_GALLERY_IMAGE_STATE,
    REMOVE_GALLERY_IMAGE,
} from './productsActionTypes';
import { API_DOMAIN, API_DOMAIN_LOCAL } from '../../api/ApiEnv';

const productsInitialSate = {
    productsData: [],
    productsSummary: {},
    productCategories: [],
    productsTotalPages: 0,
    productInputData: {
        id: 0,
        name: '',
        permalink: API_DOMAIN_LOCAL,
        virtual: false,
        downloadable: false,
        downloads: [],
        download_limit: -1,
        download_expiry: -1,
        images: [],
        featureImage: {},
        galleryImages: [],
        price: '',
        regular_price: '',
        sales_price: '',
        date_on_sale_from: '',
        date_on_sale_to: '',
        description: '',
        short_description: '',
        sku: '',
        stock_status: '',
        manage_stock: false,
        stock_quantity: null,
        backorders: 'no',
        sold_individually: false,
        purchase_note: '',
        reviews_allowed: false,
        status: 'publish',
        categories: [],
    },
    resetInputData: {
        id: 0,
        name: '',
        permalink: API_DOMAIN_LOCAL,
        virtual: false,
        downloadable: false,
        downloads: [],
        download_limit: -1,
        download_expiry: -1,
        images: [],
        featureImage: {},
        galleryImages: [],
        price: '',
        regular_price: '',
        sales_price: '',
        date_on_sale_from: '',
        date_on_sale_to: '',
        description: '',
        short_description: '',
        sku: '',
        stock_status: '',
        manage_stock: false,
        stock_quantity: null,
        backorders: 'no',
        sold_individually: false,
        purchase_note: '',
        reviews_allowed: false,
        status: 'publish',
        categories: [],
    },
    loading: false,
    disable: false,
    coverImageLoader: false,
    galleryLoader: false,
};

const productsReducer = (state = productsInitialSate, { type, payload, productsTotalPages }) => {
    switch (type) {
        // Get Product data (Initial, filtered, Mutated)
        case FETCH_PRODUCTS_DATA:
            return {
                ...state,
                productsData: payload,
                productsTotalPages,
            };
        // Get Product Summary data
        case FETCH_PRODUCTS_SUMMARY:
            return {
                ...state,
                productsSummary: payload,
            };
        // Handle Form input data
        case PRODUCT_FORM_INPUT:
            const productInputData = { ...state.productInputData };
            productInputData[payload.name] = payload.value;
            return {
                ...state,
                productInputData,
            };
        case PRODUCT_FORM_INPUT_ARRAY:
            // returning a copy of orignal state

            return {
                ...state, // spreading the original state
                productInputData: {
                    ...state.productInputData, // copying the original state
                    product_categories: payload.values,
                },
            };
        case PRODUCT_DOWNLOADABLE:
            return {
                ...state,
                productInputData: {
                    ...state.productInputData,
                    downloads: [...payload],
                },
            };
        case INPUT_IMAGE_FEATURE:
            // const foldImageLength = state.productInputData.images[0];
            // let fnewImages = [];

            // if (foldImageLength === 0) {
            //     fnewImages = [payload];
            // } else if (state.productInputData.images[0].position === 0) {
            //     fnewImages = [payload, ...state.productInputData.images];
            // }

            return {
                ...state, // spreading the original state
                productInputData: {
                    ...state.productInputData,
                    featureImage: payload,
                },
            };
        case INPUT_IMAGE_MULTIPLE:
            return {
                ...state, // spreading the original state
                productInputData: {
                    ...state.productInputData,
                    galleryImages: [...state.productInputData.galleryImages, payload],
                },
            };
        case REMOVE_GALLERY_IMAGE:
            return {
                ...state,
                productInputData: {
                    ...state.productInputData,
                    galleryImages: state.productInputData.galleryImages.filter(
                        (item) => item !== payload
                    ),
                },
            };
        case GET_PRODUCT_CATEGORIES:
            // returning a copy of orignal state
            return {
                ...state, // spreading the original state
                productCategories: payload,
            };
        case SET_SINGLE_PRODUCT:
            const splitFeature = payload.images.filter((item) => item.is_featured === true);
            const splitGallery = payload.images.filter((item) => item.is_featured === false);
            // eslint-disable-next-line no-return-assign
            splitGallery.forEach((item, index) => {
                item.position = index + 1;
            });
            const isFeature = Object.assign({}, ...splitFeature);
            const empty = [];
            // returning a copy of orignal state
            return {
                ...state, // spreading the original state
                productInputData: {
                    ...state.productInputData,
                    ...payload,
                    featureImage: isFeature,
                    galleryImages: [...splitGallery],
                    images: [...empty],
                },
            };
        case SET_LOADING_STATE:
            return {
                ...state,
                loading: payload,
            };
        case SET_COVER_IMAGE_STATE:
            return {
                ...state,
                coverImageLoader: payload,
            };
        case SET_GALLERY_IMAGE_STATE:
            return {
                ...state,
                galleryLoader: payload,
            };
        case RESET_PRODUCT_FORM:
            return {
                ...state,
                productInputData: payload,
            };
        case DELETE_PRODUCT:
            return {
                ...state,
                productsData: payload,
            };
        case RESET_FEATURE_IMAGE:
            return {
                ...state,
                productInputData: {
                    ...state.productInputData,
                    featureImage: payload,
                },
            };
        default:
            return state;
    }
};

export default productsReducer;
